import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { ClientSeedPost, IclientseedDev, IpostDealer } from './seedinterfaces';

@Injectable({
  providedIn: 'root'
})
export class SeedService {

  constructor(private http: HttpClient) { }
  getConfigAdGroups() {
    return this.http.get("api/AdMaker/AdGroups");
  }
  getConfigAdSeeds() {
    return this.http.get("api/ConfigAdSeeds");
  }
  deleteConfigAdSeeds(id: number) {
    return this.http.delete("api/ConfigAdSeeds/" + id);
  }
  getConfigAdSeedsDealer() {
    return this.http.get("api/Dealer/DealersKeywordConfig");
  }
  saveConfigAdseed(seedConf: ClientSeedPost) {
    return this.http.post("api/ConfigAdSeeds", seedConf);
  }
  saveConfigAdseedDealers(DealerKeyword: IpostDealer) {
    return this.http.post("api/Dealer/DealersKeywordConfig", DealerKeyword);
  }


  @Output() refresher = new EventEmitter<string>();
  @Output() sender = new EventEmitter<Boolean>();
  @Output() reciever = new EventEmitter<IclientseedDev[]>();
}
export const SEED = "seed";
export const NOCLIENTSEED = "noClientseed";
export const RELOADNEWVALUES = "reloadnewvalues";
export const GETNEWVALUES = "getnewvalues";
export const FORDEARLERDATA = "fordealerdata";
